import { useCreateNicheDashboardModalModel } from './create-niche-dashboard-modal.model'
import type { ICreateNicheDashboardModal } from './create-niche-dashboard-modal.types'
import { CreateNicheDashboardModalView } from './create-niche-dashboard-modal.view'

export const CreateNicheDashboardModal = (props: ICreateNicheDashboardModal) => {
  const createNicheDashboardModalModel = useCreateNicheDashboardModalModel({ ...props })
  return <CreateNicheDashboardModalView {...createNicheDashboardModalModel} {...props} />
}
